import {
    Button,
    FormHelperText,
    IconButton,
    MenuItem,
    Modal,
    MuiThemeProvider,
    Paper,
    TextField,
    Typography,
    withStyles
} from '@material-ui/core';
import css from './AddTruck.module.css';
import cs from 'classnames';
import Downshift from 'downshift';
import deburr from 'lodash/deburr';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from 'components/TrustCenter/store/actions';
import * as Constants from 'constants/Constants';
import { isEmptyList, isNotBlank, isNotEmptyList } from 'components/Common/Utils/StringUtils';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';

const styles = (theme) => ({
    paper: {
        position: 'absolute',
        borderRadius: 5,
        width: '560px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '10px 20px',
        outline: 'none'
    },
    root: {
        flexGrow: 1
    },
    container: {
        flexGrow: 1,
        position: 'relative',
        width: '100%'
    },
    dropDownPaper: {
        position: 'fixed',
        zIndex: 15000,
        maxHeight: 200,
        overflowY: 'auto'
    },
    inputRoot: {
        flexWrap: 'wrap'
    },
    inputInput: {
        width: '100%',
        flexGrow: 1
    },
    divider: {
        height: 4
    },
    spacing: 2
});

function getModalStyle() {
    const top = 25;
    const left = 33;

    return {
        top: `${top}%`,
        left: `${left}%`
    };
}

const AddTruck = (props) => {
    const {
        classes,
        showAddTruckModel,
        showAddTruck,
        newTruckRequest,
        mobilityData,
        newTruckAgreementList,
        addNewTruck,
        newTruckAgreements,
        closeAddTruckModel,
        clearTruck,
        removeTruck,
        agreements
    } = props;

    const [modalStyle] = useState(getModalStyle);

    const [showSearchTruck, setShowSearchTruck] = useState(false);

    let selectedItem = '';

    const [truckInputEditList, setTruckInputEditList] = useState([]);

    const [inValidTruckErrorList, setInValidTruckErrorList] = useState([]);

    const [popperNode, setPopperNode] = useState(null);

    const [errorText, setErrorText] = useState({
        truckNumber: '',
        timing: '',
        duplicateTrucks: ''
    });

    useEffect(() => {
        clearTruck();
    }, [clearTruck]);

    const isNoTruckFound = mobilityData.length === 0;

    const getSuggestions = (value) => {
        setErrorText('');

        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;

        let vehicleData = mobilityData.map((truck) => truck.truck_number);
        return inputLength === 0
            ? []
            : vehicleData.filter((suggestion) => {
                  return suggestion.toString().slice(0, inputLength).toLowerCase() === inputValue;
              });
    };

    const sendSelectedTruck = (suggestion) => {
        setShowSearchTruck(false);
        let truckEditMap = [...truckInputEditList];
        let index = Object.keys(truckEditMap).length;
        truckEditMap[index] = {};
        setTruckInputEditList([...truckEditMap]);
        let truckMap = {};
        let agreement = {};
        agreement.truck_number = suggestion;
        agreement.truck_id = mobilityData.filter(
            (truck) => truck.truck_number === suggestion
        )[0].vehicle_id;
        agreement.status = true;
        agreement.agreement_type = Constants.AGREEMENT_TRUCK;
        agreement.group_name = Constants.GPS_ONLY;
        truckMap.truck_id = agreement.truck_id;
        truckMap.truck_number = suggestion;
        truckMap.newTruck = agreement;
        addNewTruck(agreement);
    };

    const toggleTruckSearch = () => {
        if (!isNoTruckFound) {
            setShowSearchTruck(!showSearchTruck);
        }
    };

    const renderInput = (inputProps) => {
        const { InputProps, classes, ref, ...other } = inputProps;

        return (
            <TextField
                onBlur={() => toggleTruckSearch()}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        root: classes.inputRoot,
                        input: classes.inputInput
                    },
                    ...InputProps
                }}
                {...other}
            />
        );
    };

    const handleChange = (item) => {
        sendSelectedTruck(item);
        let tempInvalidErrorList = [...inValidTruckErrorList];
        setInValidTruckErrorList([...tempInvalidErrorList]);
    };

    const toggleTruckSearchComponent = () => {
        const renderSuggestion = (
            groupNamesSuggestion,
            index,
            itemProps,
            highlightedIndex,
            selectedItem
        ) => {
            const isHighlighted = highlightedIndex === index;
            const isSelected = (selectedItem || '').indexOf(groupNamesSuggestion) > -1;

            return (
                <MenuItem
                    {...itemProps}
                    key={groupNamesSuggestion}
                    selected={isHighlighted}
                    component="div"
                    style={{
                        fontWeight: isSelected ? 500 : 400,
                        overflowY: 'auto'
                    }}
                >
                    {groupNamesSuggestion}
                </MenuItem>
            );
        };

        renderSuggestion.propTypes = {
            highlightedIndex: PropTypes.number,
            index: PropTypes.number,
            itemProps: PropTypes.object,
            selectedItem: PropTypes.string,
            suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired
        };

        if (showSearchTruck) {
            return (
                <Downshift
                    id="downshift-simple"
                    onChange={handleChange}
                    selectedItem={selectedItem}
                >
                    {({
                        getInputProps,
                        getItemProps,
                        getMenuProps,
                        highlightedIndex,
                        inputValue,
                        selectedItem
                    }) => (
                        <div className={classes.container}>
                            {renderInput({
                                fullWidth: true,
                                classes,
                                InputProps: getInputProps({
                                    autoFocus: true
                                }),
                                ref: (node) => {
                                    setPopperNode(node);
                                }
                            })}
                            <div {...getMenuProps()}>
                                {inputValue.trim() !== '' ? (
                                    <Paper
                                        className={classes.dropDownPaper}
                                        anchorel={popperNode}
                                        square
                                        style={{
                                            position: 'fixed',
                                            minWidth: popperNode
                                                ? popperNode.clientWidth
                                                : undefined,
                                            width: 'max-content',
                                            zIndex: 1500000
                                        }}
                                    >
                                        {getSuggestions(inputValue).map((suggestion, index) =>
                                            renderSuggestion(
                                                suggestion,
                                                index,
                                                getItemProps({ item: suggestion }),
                                                highlightedIndex,
                                                selectedItem
                                            )
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        </div>
                    )}
                </Downshift>
            );
        }
        return (
            <div id={'addTruckButton'} onClick={toggleTruckSearch}>
                {!isNoTruckFound ? 'add Truck' : 'No Vehicles'}
            </div>
        );
    };

    const validateTruckInfo = () => {
        setErrorText('');
        let truckList = [];
        if (isNotEmptyList(agreements[Constants.GPS_ONLY])) {
            truckList = agreements[Constants.GPS_ONLY];
        }

        let errorTruckList = [];

        let errorEnteredTruckList = [];

        let error = {};
        if (newTruckRequest.length === 0) {
            error.truckNumber = 'Truck Number' + Constants.IS_REQUIRED;
            setErrorText(error);
            return true;
        }
        let allTruckList = [];

        allTruckList = allTruckList.concat(newTruckAgreementList);
        allTruckList = allTruckList.concat(newTruckRequest);

        newTruckRequest.forEach((tr, index) => {
            if (
                allTruckList.filter((newTruck) => {
                    if (tr.truck_number === newTruck.truck_number) {
                        return true;
                    }
                    return false;
                }).length > 1
            ) {
                if (!errorEnteredTruckList.includes(tr.truck_number)) {
                    errorEnteredTruckList.push(tr.truck_number);
                }
            }
            truckList.forEach((truck) => {
                if (tr.truck_number === truck.truck_number) {
                    errorTruckList.push(tr.truck_number);
                }
            });
        });

        if (errorEnteredTruckList.length > 0) {
            error.duplicateTrucks =
                errorEnteredTruckList.join(', ') + ' - You have entered same Truck Information';
            setErrorText(error);
            return true;
        } else if (errorTruckList.length > 0) {
            error.timing = '';
            error.duplicateTrucks =
                errorTruckList.join(', ') +
                ' - An Agreement with entered Truck Information already exists!';
            setErrorText(error);
            return true;
        } else {
            setErrorText('');
            return false;
        }
    };

    const createAgreement = () => {
        const isNotValid = validateTruckInfo();
        if (!isNotValid) {
            let temp = [...newTruckRequest];
            temp.forEach((request) => {
                request.truck_id = mobilityData.filter(
                    (truck) => truck.truck_number === request.truck_number
                )[0].vehicle_id;
            });
            newTruckAgreements(temp);
            closeDialog();
        }
    };

    const closeDialog = () => {
        closeAddTruckModel();
        setErrorText('');
        showAddTruck(false);
        clearTruck();
        setShowSearchTruck(false);
    };

    const disableAdd = () => {
        return isEmptyList(newTruckRequest) || isNotBlank(errorText);
    };

    const handleRemoveTruck = (index, agreement) => {
        setErrorText('');
        removeTruck(index);
        let truckEditMap = [...truckInputEditList];
        truckEditMap.splice(index, 1);
        setTruckInputEditList([...truckEditMap]);
    };

    return (
        <div className="full-width">
            <Modal open={showAddTruckModel}>
                <Paper style={modalStyle} className={classes.paper}>
                    <Typography variant="h6" id="modal-title">
                        Add Trucks
                    </Typography>
                    <Paper elevation={0} className={css.truckTableBase}>
                        <div className={cs(css.truckTable)}>
                            <div className={cs(css.tableHeader, 'row no-gutters')}>
                                <div className={cs('col-sm-12')}>Truck ID</div>
                            </div>

                            <div className={cs('row no-gutters', css.tableBody, css.addTruck)}>
                                <div className={cs('col-sm-12 align-self-center')}>
                                    {toggleTruckSearchComponent()}
                                </div>
                            </div>
                            <div className={cs(css.tableBodyBase)}>
                                {newTruckRequest.map((agreement, index) => {
                                    return (
                                        <div
                                            className={cs('row no-gutters', css.tableBody)}
                                            key={index}
                                        >
                                            <div
                                                className={cs('col-sm-9 align-self-center')}
                                                id={'truck_number'}
                                            >
                                                {agreement.truck_number}
                                            </div>
                                            <div className={cs('col-sm-3')}>
                                                <div className="col-sm-3 align-self-center">
                                                    <IconButton
                                                        onClick={() =>
                                                            handleRemoveTruck(index, agreement)
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-trash',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Paper>
                    <div>
                        <FormHelperText style={{ color: 'red' }}>
                            {errorText.truckNumber}
                            <br />
                            {errorText.duplicateTrucks}
                        </FormHelperText>
                        <div className={cs(css.actionButton, 'row no-gutters justify-content-end')}>
                            <div className={cs('row justify-content-end', css.actionButton)}>
                                <div className="col-sm-auto">
                                    <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                                        <Button id={'cancel'} onClick={() => closeDialog()}>
                                            CANCEL
                                        </Button>
                                    </MuiThemeProvider>
                                    <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                                        <Button
                                            id={'add'}
                                            disabled={disableAdd()}
                                            onClick={() => createAgreement()}
                                        >
                                            ADD
                                        </Button>
                                    </MuiThemeProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => ({
    newTruckRequest: state.agreement.newTruckRequest,
    newTruckAgreementList: state.agreement.newTruckAgreements,
    mobilityData: state.agreement.mobilityData,
    currentAgreement: state.agreement.currentGroup,
    session: state.session.sessionValue
});

const mapDispatchToProps = (dispatch) => {
    return {
        addNewTruck: (agreements) => dispatch(actions.addNewTruck(agreements)),
        newTruckAgreements: (truckAgreements) => {
            dispatch(actions.newTruckAgreements(truckAgreements));
        },
        removeTruck: (index) => {
            dispatch(actions.removeTruck(index));
        },
        clearTruck: () => {
            dispatch(actions.clearTruck());
        },
        showAddTruck: (showPopup) => {
            dispatch(actions.showAddTruck(showPopup));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddTruck));
